//import { Component, Input} from '@angular/core';
import * as Highcharts from 'highcharts';
import variablePie from 'highcharts/modules/variable-pie';
import HC_accessibility from 'highcharts/modules/accessibility';
import { HttpClient } from '@angular/common/http';
import { PiechartService } from '../../piechart.service';
import { Observable } from 'rxjs';
import * as _ from 'lodash';
import { normalizePercentage } from 'src/app/modules/snapshot/custom-snapshot-chart-modules/chart-value.util';
import {
  Component,
  Input,
  SimpleChanges,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { InsightspopupService } from 'src/app/common/services/insightspopup.service';
import {
  COMMON_CONSTANTS,
  COMMON_CONSTANTS_Percentage,
  COMMON_CONSTANTS_SNAPSHOT,
} from 'src/app/common/constants/common-constants';

function roundChangeText(changeText: any): any {
  return changeText == null || changeText === 'NA'
    ? changeText
    : Math.round(Number(changeText));
}

@Component({
  selector: 'app-piechart12-custom',
  templateUrl: './piechart12.component.html',
  styleUrls: [],
})
export class Piechart12ComponentCustom {
  constructor(
    private http: HttpClient,
    private piechartservice: PiechartService,
    private _customSnapshotService: CustomsnapshotService,
    private router: Router,
    private route: ActivatedRoute,
    private _configService: SnapshotService,
    public _insightsSerive: InsightspopupService,
  ) {}
  @Input() gridTempleteColumns: any;
  @Input() popUpp: any;
  @Input() popUp: any;
  @Input() customData: any;
  @Input() id: any = 0;
  @Input() sort: any;
  @Input() WidgetDetails: any;
  @Input() height: any;
  @Input() isOutput: any;
  jsondata: any;
  seriescolor: any;
  seriesgradientcolor: any;
  chartproperties: any;
  samplesizeconstant: any;
  chartimagepath: any;
  maxDataPoints: any = 2;
  significance2: any;
  private updateSigSub: Subscription | null = null;
  innerMetricName: string = '';
  innerMetricValue: string = '';
  innerCircleDisplayValue: string | null = null;
  innerCircleLabel: string | null = null;
  innerMetricObj: any = null;
  innerCircleName: string | null = null;
  innerCircleSigText: string | null = null;
  innerCircleSigColor: string = 'black';
  get insightsOpen(): boolean {
    return this._insightsSerive.insightsopen;
  }

  significanceValue: any = 'None';
  chartMainData: any = [];
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  DefaultConfidenceLevel: any = '';
  cohorts: any[] = [];
  isMultiCohort: boolean = false;
  @Input() selectedBrand: any = '';
  @Input() multiPropellerPopup: boolean = false;
  brandList: any = [];
  isMultiBrand: boolean = false;
  brands: any[] = [];
  sharedLegendChart: any;
  globalColorMapping: Map<string, string> = new Map();
  metricColorMap: Map<string, number> = new Map();
  private subscriptions: Subscription = new Subscription();
  configuredProperties: any;
  containerHeight: string = '11em';
  chartHeight: string = '100%';
  //private updateSigSub: Subscription | null = null;
  userselectedchartdata: any;
  private updateHeights(): void {
    this.containerHeight =
      this.multiPropellerPopup && this.height ? this.height : '100%';
    this.chartHeight = '100%';
    this.updateChartContainerClasses();
  }

  // private updateHeights(): void {
  //   if (this._insightsSerive.insightsopen) {
  //     this.containerHeight = '11rem';
  //     this.chartHeight = '11rem';
  //   } else {
  //     this.containerHeight = '11em';
  //     this.popUp ? this.chartHeight = '30rem' : this.chartHeight = '100%';
  //   }
  //   this.updateChartContainerClasses();
  //   // Dynamically update legend y position without full re-render
  //   if (this.chart) {
  //     const isOpen = this._insightsSerive.insightsopen;
  //     // Apply only if legend exists
  //     this.chart.update({
  //       legend: {
  //         y: isOpen ? 0 : (this.chartproperties?.legendPosition === 'bottom' ? (this.popUp ? -35 : -50) : -30)
  //       }
  //     }, false); // defer redraw until after potential other updates
  //     this.chart.redraw();
  //   }
  // }
  private updateChartContainerClasses(): void {
    const chartContainer = document.getElementById('chart-container' + this.id);
    if (chartContainer) {
      if (this._insightsSerive.insightsopen) {
        chartContainer.classList.add('insights-open');
      } else {
        chartContainer.classList.remove('insights-open');
      }
    }
  }
  ngOnInit(): void {
    // Initialize insights state and set up subscription
    this.updateHeights();

    // Subscribe to insights service changes to update heights dynamically
    this.subscriptions.add(
      this._insightsSerive.isInsightsSnapshot$.subscribe((insights) => {
        // Update the insightsopen property when insights show/hide
        if (insights) {
          this._insightsSerive.insightsopen = insights.show;
          this.updateHeights();
        }
      }),
    );

    // Also subscribe to the regular insights observable
    this.subscriptions.add(
      this._insightsSerive.isInsights$.subscribe((insights) => {
        if (insights) {
          this._insightsSerive.insightsopen = insights.show;
          this.updateHeights();
        }
      }),
    );

    if (this.isOutput) {
      this.chartimagepath = this.piechartservice.chartimagepath;

      //this.configuredProperties = JSON.parse(this.customData.customizationProperties);
      this.configuredProperties = this.customData.customizationProperties
        ? JSON.parse(this.customData.customizationProperties)
        : undefined;

      // Check if this is a multi-cohort scenario
      this.checkMultiCohort();

      // Check if this is a multi-brand scenario
      this.checkMultiBrand();

      if (!this.isMultiCohort && !this.isMultiBrand) {
        // Single chart logic
        this.innerMetricObj =
          this.customData.metric?.find(
            (m: any) =>
              m.isInnerCircle === true ||
              m.metric_option === 'Metric Inner Circle : ',
          ) ?? null;
        this.innerCircleName =
          this.innerMetricObj?.metric_value?.[0]?.option ?? null;
        this.customData = this.customData.metric[0];
        this.customData.metric_value.sort(
          (a: any, b: any) => a.selectorder - b.selectorder,
        );
      }

      this.maxDataPoints = this.popUp ? 6 : this.maxDataPoints;
      this.subscriptions.add(
        this._configService.confedenceValue.subscribe((value) => {
          this.DefaultConfidenceLevel = value;
          this.updateSig();
        }),
      );
      this.subscriptions.add(
        this._configService.significanceValue.subscribe((value) => {
          this.significanceValue = value;
          this.updateSig();
        }),
      );
      if (
        this._configService.selectedSnapshotType
          .toLowerCase()
          .includes('multi') &&
        !this.multiPropellerPopup &&
        !this.isMultiBrand
      ) {
        this.subscriptions.add(
          this._customSnapshotService
            .getSelectedBrand(this.id)
            .subscribe((selectedBrand) => {
              this.selectedBrand = selectedBrand;
              if (this.selectedBrand != undefined || this.selectedBrand != '') {
                this.updateSig();
              }
            }),
        );
      }
      if (this.multiPropellerPopup) {
        // selectedBrand is passed as @Input; just plot directly
        this.updateSig();
      }
    } else {
      this.http.get<any>('assets/Data/piechart.json').subscribe((data) => {
        this.jsondata = data[0];
        this.chartproperties = this.jsondata['properties'][0];
        this.chartproperties.showLegend = true;
        this.chartproperties.legendPosition = 'bottom';
        this.chartproperties.decimalRoundOff = 2;
        this.seriescolor = this.piechartservice.color;
        this.seriesgradientcolor = this.piechartservice.linearGradients1;
        this.chartimagepath = this.piechartservice.chartimagepath;
        this.samplesizeconstant = this.piechartservice.samplesizeconstant;
        // this.plotChart('chart-container'+this.id,this.jsondata['data'], this.chartproperties);
        this.route.paramMap.subscribe((params) => {
          const userData = history.state.userData;
          this.userselectedchartdata = userData; // Use the userData object as needed
          if (this.userselectedchartdata?.widgetEditSelection) {
            if (
              this.userselectedchartdata?.widgetEditSelection
                ?.customizationProperties != ''
            ) {
              this.chartproperties = JSON.parse(
                this.userselectedchartdata?.widgetEditSelection
                  ?.customizationProperties,
              );
            }
          }
        });
        this.plotChart(
          'chart-container' + this.id,
          this.jsondata['data'],
          this.chartproperties,
        );
      });
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    // Update heights when insights state changes
    this.updateHeights();

    if (changes['customData'] && !changes['customData'].firstChange) {
      if (this.isOutput) {
        //this.configuredProperties = JSON.parse(this.customData.customizationProperties);
        this.configuredProperties = this.customData.customizationProperties
          ? JSON.parse(this.customData.customizationProperties)
          : undefined;
        this.checkMultiCohort();
        this.checkMultiBrand();
        if (!this.isMultiCohort && !this.isMultiBrand) {
          this.innerMetricObj =
            this.customData.metric?.find(
              (m: any) =>
                m.isInnerCircle === true ||
                m.metric_option === 'Metric Inner Circle : ',
            ) ?? null;
          this.innerCircleName =
            this.innerMetricObj?.metric_value?.[0]?.option ?? null;
          this.customData = this.customData.metric[0];
          this.customData.metric_value.sort(
            (a: any, b: any) => a.selectorder - b.selectorder,
          );
        }
        this.updateSig();
      }
    }
  }

  ngAfterViewInit(): void {
    if (this.isOutput && (this.isMultiCohort || this.isMultiBrand)) {
      // Render all cohort/brand charts after view init
      setTimeout(() => {
        this.updateSig();
      }, 100);
    }
  }

  // ngOnInit(): void {
  //   this.http.get<any>('assets/Data/piechart.json').subscribe((data) => {
  //     this.jsondata = data[0];
  //     this.chartproperties = this.jsondata['properties'][0];
  //     this.chartproperties.decimalRoundOff=0;
  //     this.seriescolor = this.piechartservice.color;
  //     this.chartimagepath=this.piechartservice.chartimagepath;
  //     this.seriesgradientcolor=this.piechartservice.linearGradients1;
  //     this.samplesizeconstant=this.piechartservice.samplesizeconstant;
  //     this.plotChart('chart-container', this.jsondata['data'], this.chartproperties);
  //   });
  // }

  checkMultiCohort(): void {
    if (this._configService.multiCohort) {
      const metricValues = this.customData.metric[0].metric_value;

      // Extract unique cohorts from colChild in the data array
      const cohortSet = new Set<string>();

      // Parse through all metric values to find unique cohorts
      metricValues.forEach((mv: any) => {
        if (mv.data && mv.data.length > 0) {
          mv.data.forEach((dataItem: any) => {
            if (dataItem.colChild) {
              // Extract cohort name from colChild (e.g., "Audience|Gender|Male" -> "Male")
              const parts = dataItem.colChild.split('|');
              if (parts.length > 0) {
                const cohortName = parts[parts.length - 1]; // Get the last part (e.g., "Male", "Female")
                cohortSet.add(cohortName);
              }
            }
          });
        }
      });

      const uniqueCohorts = Array.from(cohortSet);

      // If we have multiple cohorts, enable multi-cohort mode
      if (uniqueCohorts.length > 1) {
        this.isMultiCohort = true;

        // Create cohort data structure
        this.cohorts = uniqueCohorts.map((cohortName) => {
          return {
            title: cohortName,
            metric_value: metricValues
              .map((mv: any) => {
                return {
                  ...mv,
                  data: mv.data.filter((d: any) => {
                    const parts = d.colChild ? d.colChild.split('|') : [];
                    const itemCohort = parts[parts.length - 1];
                    return itemCohort === cohortName;
                  }),
                };
              })
              .filter((mv: any) => mv.data.length > 0), // Only include metric_values that have data for this cohort
          };
        });
      } else {
      }
    }
  }

  checkMultiBrand(): void {
    this.isMultiBrand = false;
    this.brands = [];

    if (
      this._configService.selectedSnapshotType
        .toLowerCase()
        .includes('multi') &&
      !this.multiPropellerPopup &&
      this.popUp
    ) {
      const metricValues = this.customData.metric[0].metric_value;
      const brandSet = new Set<string>();

      metricValues.forEach((mv: any) => {
        if (mv.data && mv.data.length > 0) {
          mv.data.forEach((dataItem: any) => {
            if (dataItem.colChild) {
              brandSet.add(dataItem.colChild);
            }
          });
        }
      });

      const uniqueBrands = Array.from(brandSet);

      if (uniqueBrands.length > 1) {
        this.isMultiBrand = true;
        this.brands = uniqueBrands.map((brandName) => ({
          title: brandName,
          metric_value: metricValues
            .map((mv: any) => ({
              ...mv,
              data: mv.data.filter((d: any) => d.colChild === brandName),
            }))
            .filter((mv: any) => mv.data.length > 0),
        }));
      }
    }
  }

  updateSig() {
    this.updateSigSub?.unsubscribe();
    this.updateSigSub = this.http
      .get<any>('assets/Data/piechart.json')
      .subscribe((data) => {
        this.jsondata = data[0];
        this.chartproperties = this.jsondata['properties'][0];
        //this.chartproperties = this.configuredProperties != undefined ? this.configuredProperties : this.chartproperties;
        this.chartproperties =
          this.configuredProperties ?? this.chartproperties;
        this.seriescolor = this.piechartservice.color;
        this.seriesgradientcolor = this.piechartservice.linearGradients1;
        this.samplesizeconstant = this.piechartservice.samplesizeconstant;
        this.chartproperties.datalabelStyle =
          this.significanceValue == 'None' ? 'datalabel' : 'sigChange';
        this.chartproperties.dataLabelPosition = 'right';
        this.chartproperties.datalabelStyle = this._configService
          .isIndexSelected
          ? 'index'
          : this.chartproperties.datalabelStyle;

        this.Sig_LowerLimt =
          this.DefaultConfidenceLevel ==
          COMMON_CONSTANTS_Percentage.ConfidencePercent_95
            ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95
            : this.DefaultConfidenceLevel ==
                COMMON_CONSTANTS_Percentage.ConfidencePercent_90
              ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_90
              : this.DefaultConfidenceLevel ==
                  COMMON_CONSTANTS_Percentage.ConfidencePercent_98
                ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_98
                : COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95;
        this.Sig_UpperLimt =
          this.DefaultConfidenceLevel ==
          COMMON_CONSTANTS_Percentage.ConfidencePercent_95
            ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95
            : this.DefaultConfidenceLevel ==
                COMMON_CONSTANTS_Percentage.ConfidencePercent_90
              ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_90
              : this.DefaultConfidenceLevel ==
                  COMMON_CONSTANTS_Percentage.ConfidencePercent_98
                ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_98
                : COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95;

        // Set inner circle metric values
        if (!this.isMultiCohort) {
          const dataToUse = this.customData;
          this.preparemainChartData(dataToUse);

          if (
            this.chartproperties?.innerCircleMetric &&
            this.chartproperties.innerCircleMetric !== 'none' &&
            this.chartMainData.length > 0
          ) {
            const found = this.chartMainData.find(
              (d: any) =>
                d['Category Name'] == this.chartproperties.innerCircleMetric ||
                d['Series Name'] == this.chartproperties.innerCircleMetric,
            );
            this.innerMetricName = found
              ? found['Category Name'] || found['Series Name']
              : '';
            this.innerMetricValue = found
              ? found['Value'] != null
                ? Number(found['Value']).toFixed(
                    this.chartproperties.decimalRoundOff,
                  ) + (found['isPercentage'] ? '%' : '')
                : 'NA'
              : '';
          } else {
            this.innerMetricName = '';
            this.innerMetricValue = '';
          }
        }

        if (this.isMultiBrand) {
          // Build global color mapping for all brand metrics so colours are consistent
          this.globalColorMapping.clear();
          this.metricColorMap.clear();
          let colorIndex = 0;
          const isgradient = this.chartproperties.gradientBarColor;

          this.brands.forEach((brand) => {
            brand.metric_value.forEach((mv: any) => {
              if (!this.globalColorMapping.has(mv.option)) {
                const color = !isgradient
                  ? this.seriescolor[colorIndex]
                  : this.seriesgradientcolor[colorIndex];
                this.globalColorMapping.set(mv.option, color);
                colorIndex++;
              }
            });
          });

          this.brands.forEach((brand, index) => {
            this.plotChart(
              'chart-container' + this.id + '-brand-' + index,
              this.jsondata['data'],
              this.chartproperties,
              brand,
            );
          });

          // Create shared legend after all brand charts are rendered
          setTimeout(() => this.createSharedLegend(), 800);
        } else if (this.isMultiCohort) {
          this.globalColorMapping.clear();
          let colorIndex = 0;
          const isgradient = this.chartproperties.gradientBarColor;

          this.cohorts.forEach((cohort) => {
            cohort.metric_value.forEach((mv: any) => {
              mv.data.forEach((dataArr: any) => {
                const seriesName =
                  dataArr.colChild.split('|').length > 1
                    ? dataArr.colChild.split('|')[1]
                    : dataArr.colChild;

                if (!this.globalColorMapping.has(seriesName)) {
                  const color = !isgradient
                    ? this.seriescolor[colorIndex]
                    : this.seriesgradientcolor[colorIndex];
                  this.globalColorMapping.set(seriesName, color);
                  colorIndex++;
                }
              });
            });
          });

          this.cohorts.forEach((cohort, index) => {
            this.plotChart(
              'chart-container' + this.id + '-' + index,
              this.jsondata['data'],
              this.chartproperties,
              cohort,
            );
          });

          setTimeout(() => this.createSharedLegend(), 800);
        } else {
          this.plotChart(
            'chart-container' + this.id,
            this.jsondata['data'],
            this.chartproperties,
          );
        }
      });
  }
  // updateSig() {
  //   this.updateSigSub?.unsubscribe();
  //   this.updateSigSub = this.http.get<any>('assets/Data/piechart.json').subscribe((data) => {
  //       if (this.isMultiCohort) {
  //       // ... existing code
  //       if (!this.isMultiCohort) {
  //         this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
  //       }
  //       this.jsondata = data[0];
  //       this.chartproperties = this.jsondata['properties'][0];
  //       this.chartproperties = this.configuredProperties != undefined ? this.configuredProperties : this.chartproperties;
  //       this.seriescolor = this.piechartservice.color;
  //       this.seriesgradientcolor = this.piechartservice.linearGradients1;
  //       this.samplesizeconstant = this.piechartservice.samplesizeconstant;
  //       this.chartproperties.datalabelStyle = this.significanceValue == "None" ? "datalabel" : "sigChange";
  //       this.chartproperties.dataLabelPosition = 'right';
  //       this.chartproperties.datalabelStyle = this._configService.isIndexSelected ? "index" : this.chartproperties.datalabelStyle;
  //       this.Sig_LowerLimt =
  //         this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
  //           ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95
  //           : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
  //             ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_90
  //             : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_98
  //               ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_98
  //               : COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95;
  //       this.Sig_UpperLimt =
  //         this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
  //           ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95
  //           : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
  //             ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_90
  //             : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_98
  //               ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_98
  //               : COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95;

  //       if (this.isMultiCohort) {
  //         // First, build global color mapping by processing all cohorts
  //         this.globalColorMapping.clear();
  //         let colorIndex = 0;
  //         const isgradient = this.chartproperties.gradientBarColor;

  //         this.cohorts.forEach((cohort) => {
  //           cohort.metric_value.forEach((mv: any) => {
  //             mv.data.forEach((dataArr: any) => {
  //               const seriesName = dataArr.colChild.split("|").length > 1
  //                 ? dataArr.colChild.split("|")[1]
  //                 : dataArr.colChild;

  //               if (!this.globalColorMapping.has(seriesName)) {
  //                 const color = !isgradient
  //                   ? this.seriescolor[colorIndex]
  //                   : this.seriesgradientcolor[colorIndex];
  //                 this.globalColorMapping.set(seriesName, color);
  //                 colorIndex++;
  //               }
  //             });
  //           });
  //         });

  //         // Then render multiple charts for each cohort
  //         this.cohorts.forEach((cohort, index) => {
  //           this.plotChart(
  //             'chart-container' + this.id + '-' + index,
  //             this.jsondata['data'],
  //             this.chartproperties,
  //             cohort
  //           );
  //         });

  //         // Create shared legend after all charts are rendered
  //         setTimeout(() => this.createSharedLegend(), 800);
  //       } else {
  //         this.plotChart(
  //           'chart-container' + this.id,
  //           this.jsondata['data'],
  //           this.chartproperties
  //         );
  //       }

  //     });
  // }
  createMultiBrandPopupLegend(): void {
    const legendContainer = document.getElementById(
      'shared-legend-propeller-container',
    );
    if (!legendContainer) return;
    if (legendContainer.hasChildNodes()) return; // already created by another brand instance

    const innerCircleName = this.innerCircleName;
    const seriesMap = new Map<string, any>();

    // Add inner circle metric first (renders with white/empty circle in legend)
    if (innerCircleName && !seriesMap.has(innerCircleName)) {
      seriesMap.set(innerCircleName, {
        name: innerCircleName,
        y: 0,
        color: '#eeebed',
        legendkeycolor: '#eeebed',
        isInnerCircle: true,
      });
    }

    // Add regular metrics from metric_value
    (this.customData.metric_value ?? []).forEach((mv: any) => {
      const seriesName = mv.option;
      if (seriesName && !seriesMap.has(seriesName)) {
        const metricIdx = this.metricColorMap.get(seriesName);
        const isgradient = this.chartproperties.gradientBarColor;
        const color =
          metricIdx !== undefined
            ? isgradient
              ? this.seriesgradientcolor[metricIdx]
              : this.seriescolor[metricIdx]
            : this.seriescolor[0];
        seriesMap.set(seriesName, {
          name: seriesName,
          y: 0,
          color,
          legendkeycolor: color,
          isInnerCircle: false,
        });
      }
    });

    const allSeriesData = Array.from(seriesMap.values());
    if (allSeriesData.length === 0) return;

    const chartproperties = this.chartproperties;
    let legendContainerWidth =
      legendContainer.offsetWidth || legendContainer.clientWidth || 0;
    if (!legendContainerWidth || legendContainerWidth < 100) {
      const parent = legendContainer.parentElement;
      legendContainerWidth =
        parent && parent.clientWidth > 100
          ? parent.clientWidth
          : window.innerWidth
            ? Math.floor(window.innerWidth * 0.9)
            : 1000;
    }

    const popupItemWidth = Math.max(
      150,
      Math.floor((legendContainerWidth - 20) / 2),
    );
    const itemsPerRow = Math.max(
      1,
      Math.floor(legendContainerWidth / popupItemWidth),
    );
    const legendRows = Math.max(
      1,
      Math.ceil(allSeriesData.length / itemsPerRow),
    );
    const legendChartHeight = Math.max(60, Math.min(300, legendRows * 36));

    Highcharts.chart(legendContainer, {
      chart: {
        type: 'pie',
        height: legendChartHeight,
        backgroundColor: 'transparent',
        margin: [0, 0, 0, 0],
        spacing: [0, 0, 0, 0],
      },
      title: { text: '' },
      credits: { enabled: false },
      tooltip: { enabled: false },
      plotOptions: {
        pie: {
          dataLabels: { enabled: false },
          showInLegend: true,
          states: { hover: { enabled: false }, inactive: { enabled: false } },
        },
      },
      legend: {
        enabled: true,
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
        width: legendContainerWidth,
        itemWidth: popupItemWidth,
        maxHeight: legendChartHeight,
        navigation: { enabled: false },
        symbolWidth: 0,
        symbolHeight: 0,
        useHTML: true,
        itemMarginTop: 0,
        itemMarginBottom: 4,
        itemStyle: {
          fontWeight: 'normal',
          fontSize: '0.8em',
          cursor: 'default',
          whiteSpace: 'normal',
          overflow: 'visible',
        },
        labelFormatter: function (): any {
          const point = this as any;
          const textcolor = chartproperties?.darkTheme ? 'white' : 'black';
          const isInner =
            point.isInnerCircle === true || point.name === innerCircleName;
          const dotColor = point.legendkeycolor || point.color || '#ccc';
          const textMaxPx = Math.max(0, popupItemWidth - 16 - 4);
          const dotStyle = isInner
            ? 'background-color:white;border:1.5px solid #333;'
            : 'background-color:' + dotColor + ';';
          return (
            '<div style="display:flex;align-items:flex-start;font-size:0.8em;margin-bottom:4px;padding-left:2px;">' +
            //return '<div style="display:flex;align-items:flex-start;font-size:0.8em;margin-bottom:4px;">'
            '<div style="flex:0 0 10px;width:10px;height:10px;' +
            dotStyle +
            'border-radius:50%;margin-top:2px;flex-shrink:0;"></div>' +
            '<div style="flex:1;max-width:' +
            textMaxPx +
            'px;font-size:0.8em;margin-left:6px;color:' +
            textcolor +
            ';line-height:1.3;word-wrap:break-word;">' +
            point.name +
            '</div>' +
            '</div>'
          );
        },
      },
      series: [
        {
          type: 'pie',
          name: 'Legend',
          data: allSeriesData,
          size: 0,
          innerSize: 0,
          visible: false,
        },
      ],
    } as any);
  }

  createSharedLegend(): void {
    if (!this.isMultiCohort && !this.isMultiBrand) {
      return;
    }

    const legendContainer = document.getElementById('shared-legend-container');
    if (!legendContainer) {
      console.warn('Legend container not found');
      return;
    }

    // Collect all unique series from all cohorts with their colors
    const allSeriesData: any[] = [];
    const seriesMap = new Map<string, any>();

    if (this.isMultiBrand) {
      (this.customData.metric[0].metric_value as any[]).forEach((mv: any) => {
        const seriesName = mv.option;
        if (!seriesMap.has(seriesName)) {
          const mappedColor = this.globalColorMapping.has(seriesName)
            ? this.globalColorMapping.get(seriesName)
            : this.seriescolor[seriesMap.size] || '#aaa';
          seriesMap.set(seriesName, {
            name: seriesName,
            y: 0,
            color: mappedColor,
            legendkeycolor: mappedColor,
          });
        }
      });
    } else if (this.isMultiCohort) {
      this.cohorts.forEach((cohort) => {
        cohort.metric_value.forEach((mv: any) => {
          mv.data.forEach((dataArr: any) => {
            const seriesName =
              dataArr.colChild.split('|').length > 1
                ? dataArr.colChild.split('|')[1]
                : dataArr.colChild;
            if (!seriesMap.has(seriesName)) {
              const mappedColor = this.globalColorMapping.has(seriesName)
                ? this.globalColorMapping.get(seriesName)
                : this.seriescolor[seriesMap.size] || '#aaa';
              seriesMap.set(seriesName, {
                name: seriesName,
                y: 0,
                color: mappedColor,
                legendkeycolor: mappedColor,
              });
            }
          });
        });
      });
    }

    // // Get unique series across all cohorts
    // this.chartMainData.forEach((item: any) => {
    //   const seriesName = item['Series Name'];
    //   if (!seriesMap.has(seriesName)) {
    //     // Prefer the explicit global color mapping (built in updateSig/preparechartdata)
    //     const mappedColor = this.globalColorMapping && this.globalColorMapping.has(seriesName)
    //       ? this.globalColorMapping.get(seriesName)
    //       : (item['color'] || item['colorLinearGradient'] || this.seriescolor[0]);

    //     seriesMap.set(seriesName, {
    //       name: seriesName,
    //       y: 0, // Dummy value for legend
    //       // store both properties so labelFormatter can read legendkeycolor consistently
    //       color: mappedColor,
    //       legendkeycolor: mappedColor
    //     });
    //   }
    // });

    allSeriesData.push(...Array.from(seriesMap.values()));

    // Create a hidden chart just for the legend
    const chartproperties = this.chartproperties;
    const popUpState = this.popUp;
    let legendContainerWidth =
      legendContainer.offsetWidth || legendContainer.clientWidth || 0;
    // If the container is hidden or very small (e.g., measured 17px when offscreen), fall back to parent or window width
    if (!legendContainerWidth || legendContainerWidth < 100) {
      const parent = legendContainer.parentElement;
      if (parent && parent.clientWidth && parent.clientWidth > 100) {
        legendContainerWidth = parent.clientWidth;
      } else if (typeof window !== 'undefined' && window.innerWidth) {
        legendContainerWidth = Math.floor(window.innerWidth * 0.9);
      } else {
        legendContainerWidth = 1000;
      }
    }

    // For popup view, use same wide legend sizing as stack chart service (full visible legend)
    const popupLegendWidth = legendContainerWidth;
    // Use full width for legend items to avoid truncation
    const popupItemWidth = Math.max(
      150,
      Math.floor((legendContainerWidth - 20) / 2),
    );

    // Compute rows so we can give the legend chart enough height and avoid Highcharts paging (1/2 arrows)
    const legendEffectiveWidth = popUpState
      ? popupLegendWidth
      : Math.floor(legendContainerWidth);
    const itemsPerRow = Math.max(
      1,
      Math.floor(legendEffectiveWidth / popupItemWidth),
    );
    const legendRows = Math.max(
      1,
      Math.ceil(allSeriesData.length / itemsPerRow),
    );
    const legendChartHeight = Math.max(100, Math.min(500, legendRows * 32));

    this.sharedLegendChart = Highcharts.chart(legendContainer, {
      chart: {
        type: 'pie',
        height: legendChartHeight,
        backgroundColor: 'transparent',
        margin: [0, 0, 0, 0],
        spacing: [0, 0, 0, 0],
      },
      title: { text: '' },
      credits: { enabled: false },
      tooltip: { enabled: false },
      plotOptions: {
        pie: {
          dataLabels: { enabled: false },
          showInLegend: true,
          states: {
            hover: { enabled: false },
            inactive: { enabled: false },
          },
        },
      },
      legend: {
        enabled: true,
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
        // Use larger widths in popup to display full legend (match stack chart behaviour)
        width: popUpState ? popupLegendWidth : undefined,
        itemWidth: popupItemWidth,
        maxHeight: legendChartHeight,
        navigation: {
          enabled: false,
        },
        symbolWidth: 0,
        symbolHeight: 0,
        useHTML: true,
        itemMarginTop: 0,
        itemMarginBottom: 0,
        itemStyle: {
          fontWeight: 'normal',
          fontSize: '0.8em',
          cursor: 'default',
          whiteSpace: 'normal',
          overflow: 'visible',
        },
        labelFormatter: function (): any {
          let point = this as any;
          let textcolor = chartproperties?.darkTheme ? 'white' : 'black';
          let label = point.name;
          // Prefer explicit legendkeycolor set on data items
          const dotColor = point.legendkeycolor || point.color || '#ccc';
          // Calculate text max width based on legend item width to show full text
          const itemWidthPx = popupItemWidth;
          const dotWidthPx = 10;
          const gapPx = 6;
          const textMaxPx = Math.max(0, itemWidthPx - dotWidthPx - gapPx - 4);
          return (
            '<div style="display:flex;align-items:flex-start;font-size:0.8em;margin-bottom:4px;white-space:normal;width:' +
            itemWidthPx +
            'px;box-sizing:border-box;overflow:hidden;" title="' +
            point.name +
            '">' +
            '<div style="flex:0 0 ' +
            dotWidthPx +
            'px;width:' +
            dotWidthPx +
            'px;height:' +
            dotWidthPx +
            'px;background-color:' +
            dotColor +
            ';border-radius:50%;margin-top:2px;flex-shrink:0;"></div>' +
            '<div style="flex:1 1 auto;max-width:' +
            textMaxPx +
            'px;font-size:0.8em;margin-left:' +
            gapPx +
            'px;color:' +
            textcolor +
            ';line-height:1.3;word-wrap:break-word;overflow-wrap:break-word;">' +
            label +
            '</div>' +
            '</div>'
          );
        },
      },
      series: [
        {
          type: 'pie',
          name: 'Legend',
          data: allSeriesData,
          size: 0, // Hide the actual pie chart
          innerSize: 0,
          visible: false,
        },
      ],
    } as any);
  }

  // customization(): Observable<any[]> {
  //   // return this.piechartservice.PieChart1to10customizationList();
  //   const snapshotTypeSelectedName = this._customSnapshotService.selectedSnapshotType?.name;
  //   const cohortType = snapshotTypeSelectedName && snapshotTypeSelectedName.toLowerCase().includes('audience')
  //     ? this._configService.audienceCohortType
  //     : 'NA';
  //   return _.cloneDeep(this._customSnapshotService.getChartCustomization("01/Pie Chart", snapshotTypeSelectedName, cohortType));
  // }
  customization(): Observable<any> {
    // return this.piechartservice.PieChart1to10customizationList();
    const snapshotTypeSelectedName =
      this._customSnapshotService.selectedSnapshotType?.name;
    const cohortType =
      snapshotTypeSelectedName &&
      snapshotTypeSelectedName.toLowerCase().includes('audience')
        ? this._configService.audienceCohortType
        : 'NA';
    return _.cloneDeep(
      this._customSnapshotService.getChartCustomization(
        'Propeller Chart',
        snapshotTypeSelectedName,
        cohortType,
      ),
    );
  }

  preparemainChartData(data: any) {
    this.chartMainData = [];
    // this.chartproperties=this.configuredProperties!=undefined?this.configuredProperties:this.chartproperties;
    if (!data?.metric_value) return;
    if (
      this._configService.selectedSnapshotType
        .toLowerCase()
        .includes('multi') &&
      !this.isMultiBrand
    ) {
      this.brandList = [];
      data.metric_value[0].data.forEach((d: any) => {
        this.brandList.push(d.colChild);
      });
      if (this.brandList.length > 0) {
        if (this.selectedBrand == undefined || this.selectedBrand == '') {
          this.selectedBrand = this.brandList[0];
        }
        if (!this.multiPropellerPopup) {
          this._customSnapshotService.updateBrandList(
            this.id,
            this.brandList,
            this.selectedBrand,
          );
        }
      }

      // Build metric→color index map so same metric always gets the same color across brands
      this.metricColorMap = new Map();
      let metricColorIdx = 0;
      data.metric_value.forEach((lev2: any) => {
        if (!this.metricColorMap.has(lev2.option)) {
          this.metricColorMap.set(lev2.option, metricColorIdx++);
        }
      });

      data.metric_value.forEach((lev2: any) => {
        lev2.data.forEach((dataArr: any) => {
          if (dataArr.colChild == this.selectedBrand) {
            let d1 = {
              'Series Name': lev2.option,
              'Category Name': lev2.metric_group,
              'Rounded Value':
                dataArr.CalculationType?.toLowerCase() == 'share' ||
                dataArr.CalculationType?.toLowerCase() == 'respgrp'
                  ? normalizePercentage(dataArr.data)
                  : dataArr.CalculationType?.toLowerCase() == 'index' &&
                      dataArr.data == 'NA'
                    ? 'NA'
                    : dataArr.data,
              Value:
                dataArr.CalculationType?.toLowerCase() == 'share' ||
                dataArr.CalculationType?.toLowerCase() == 'respgrp'
                  ? normalizePercentage(dataArr.data)
                  : dataArr.CalculationType?.toLowerCase() == 'index' &&
                      dataArr.data == 'NA'
                    ? 'NA'
                    : dataArr.data,
              ValueForIndex:
                dataArr.CalculationType?.toLowerCase() == 'index' &&
                dataArr.data2 == 'NA'
                  ? 'NA'
                  : dataArr.data2,
              ActualIndexValue:
                dataArr.CalculationTypeIndex?.toLowerCase() == 'index' &&
                dataArr.data2 == null
                  ? null
                  : dataArr.CalculationTypeIndex?.toLowerCase() == 'index' &&
                      dataArr.data2 == 'NA'
                    ? 'NA'
                    : dataArr.data2,
              Label:
                dataArr.data == null
                  ? 'NA'
                  : dataArr.CalculationType?.toLowerCase() == 'share' ||
                      dataArr.CalculationType?.toLowerCase() == 'respgrp'
                    ? normalizePercentage(dataArr.data)
                    : dataArr.CalculationType?.toLowerCase() == 'index' &&
                        dataArr.data == 'NA'
                      ? 'NA'
                      : dataArr.data,
              'Change value vs PY': dataArr.changeVsPY,
              Significance: '-1',
              'Sample size': dataArr.baseValueforLSorIs,
              Significance2: '1',
              isPercentage:
                dataArr.CalculationType?.toLowerCase() == 'share' ||
                dataArr.CalculationType?.toLowerCase() == 'respgrp'
                  ? true
                  : false,
              Sig_LowerLimt: this.Sig_LowerLimt,
              Sig_UpperLimt: this.Sig_UpperLimt,
              Significance_Value: dataArr.Significance_Value,
              color: dataArr.color,
              colorLinearGradient: dataArr.colorLinearGradient,
            };
            this.chartMainData.push(d1);
          }
        });
      });
    } else {
      let i = 0;
      data.metric_value.forEach((lev2: any) => {
        lev2.data.forEach((dataArr: any) => {
          let d1 = {
            'Series Name': lev2.option,
            'Category Name': lev2.metric_group || dataArr.colChild,
            'Rounded Value':
              dataArr.CalculationType?.toLowerCase() == 'share' ||
              dataArr.CalculationType?.toLowerCase() == 'respgrp'
                ? normalizePercentage(dataArr.data)
                : dataArr.CalculationType?.toLowerCase() == 'index' &&
                    dataArr.data == 'NA'
                  ? 'NA'
                  : dataArr.data,
            Value:
              dataArr.CalculationType?.toLowerCase() == 'share' ||
              dataArr.CalculationType?.toLowerCase() == 'respgrp'
                ? normalizePercentage(dataArr.data)
                : dataArr.CalculationType?.toLowerCase() == 'index' &&
                    dataArr.data == 'NA'
                  ? 'NA'
                  : dataArr.data,
            ValueForIndex:
              dataArr.CalculationType?.toLowerCase() == 'index' &&
              dataArr.data2 == 'NA'
                ? 'NA'
                : dataArr.data2,
            ActualIndexValue:
              dataArr.CalculationTypeIndex?.toLowerCase() == 'index' &&
              dataArr.data2 == null
                ? null
                : dataArr.CalculationTypeIndex?.toLowerCase() == 'index' &&
                    dataArr.data2 == 'NA'
                  ? 'NA'
                  : dataArr.data2,
            Label:
              dataArr.data == null
                ? 'NA'
                : dataArr.CalculationType?.toLowerCase() == 'share' ||
                    dataArr.CalculationType?.toLowerCase() == 'respgrp'
                  ? normalizePercentage(dataArr.data)
                  : dataArr.CalculationType?.toLowerCase() == 'index' &&
                      dataArr.data == 'NA'
                    ? 'NA'
                    : dataArr.data,
            'Change value vs PY': dataArr.changeVsPY,
            Significance: '-1',
            'Sample size': dataArr.baseValueforLSorIs,
            Significance2: '1',
            isPercentage:
              dataArr.CalculationType?.toLowerCase() == 'share' ||
              dataArr.CalculationType?.toLowerCase() == 'respgrp'
                ? true
                : false,
            Sig_LowerLimt: this.Sig_LowerLimt,
            Sig_UpperLimt: this.Sig_UpperLimt,
            Significance_Value: dataArr.Significance_Value,
            color: dataArr.color,
            colorLinearGradient: dataArr.colorLinearGradient,
          };
          this.chartMainData.push(d1);
        });
      });
    }
  }
  preparechartdata(data: any, islowsample: any, isgradient: any) {
    if (this.isOutput) {
      let seriesdata: any[] = [];
      let cov: any = [];
      let significance: any = [];
      let samplesize: any = [];
      let label: any = [];
      let i = 0;
      let innerSize = 40;
      let size = 35;
      let d: any = {};
      d.animation = this.piechartservice.allowAnimation;
      d.zMin = 0; // ← ADD THIS
      //d.zMax = 100; // ← ADD THIS
      d.data = [];
      data.forEach((dat: any) => {
        cov.push(dat['Change value vs PY']);
        significance.push(dat['Significance']);
        label.push(dat['Label']);
        samplesize.push(dat['Sample size']);
        let value =
          isNaN(parseFloat(dat['Value'])) || parseFloat(dat['Value']) == null
            ? null
            : parseFloat(
                Number(dat['Value']).toFixed(
                  this.chartproperties.decimalRoundOff,
                ),
              );
        let finalvalue = !islowsample
          ? value
          : parseFloat(dat['Sample size']) > this.samplesizeconstant
            ? value
            : 0;

        // For multi-cohort, ensure consistent colors across cohorts
        const seriesName = dat['Series Name'];
        let assignedColor: string;

        if (this.isMultiCohort) {
          // Check if this series already has a color assigned
          if (!this.globalColorMapping.has(seriesName)) {
            // Assign a new color from the palette
            const colorIndex = this.globalColorMapping.size;
            assignedColor = !isgradient
              ? this.seriescolor[colorIndex]
              : this.seriesgradientcolor[colorIndex];
            this.globalColorMapping.set(seriesName, assignedColor);
          } else {
            // Use the already assigned color
            assignedColor = this.globalColorMapping.get(seriesName)!;
          }
        } else if (this.metricColorMap.size > 0) {
          // Multi-brand mode - use metric-based color so same metric always gets the same color
          const metricIdx = this.metricColorMap.get(seriesName) ?? i++;
          assignedColor = !isgradient
            ? this.seriescolor[metricIdx]
            : this.seriesgradientcolor[metricIdx];
        } else {
          // Single cohort mode - use existing logic
          assignedColor = dat['color']
            ? dat['color']
            : !isgradient
              ? this.seriescolor[i++]
              : this.seriesgradientcolor[i++];
        }

        let m = {
          name: dat['Series Name'],
          y:
            this._configService.userRole != 'superadmin' &&
            Number(dat['Sample size']) <= this._configService.ISthreshold
              ? 0
              : finalvalue == null
                ? 0
                : finalvalue,
          indexValue:
            this._configService.userRole != 'superadmin' &&
            Number(dat['Sample size']) <= this._configService.ISthreshold
              ? 0
              : dat['ValueForIndex'] == null
                ? 0
                : dat['ValueForIndex'],
          actualIndexValue: dat['ActualIndexValue'],
          y1: this._configService.isIndexSelected
            ? finalvalue
            : this._configService.userRole != 'superadmin' &&
                Number(dat['Sample size']) <= this._configService.ISthreshold
              ? 0
              : finalvalue == null
                ? 0
                : finalvalue,
          z: finalvalue ? finalvalue * 2 : 10,
          // zmax: 100,

          legendkeycolor: assignedColor,
          actualcolor: assignedColor,
          color: assignedColor,

          cov: dat['Change value vs PY'],
          significance: dat['Significance'],
          significance2: dat['Significance2'],
          samplesize: dat['Sample size'],
          tooltip: '',
          isPercentage: dat['isPercentage'],
          Sig_LowerLimt: this.Sig_LowerLimt,
          Sig_UpperLimt: this.Sig_UpperLimt,
          //Significance_Value: dat["Significance_Value"]
          Significance_Value: dat['Significance_Value'],
        };

        // Increment i only for non-multi-cohort mode
        if (!this.isMultiCohort && !dat['color']) {
          i++;
        }

        d.data.push(m);
        this.datalength++;
      });
      seriesdata = [d];

      d = {};
      this.cov = cov;
      this.significance = significance;
      this.label = label;
      this.samplesize = samplesize;
      this.seriesdata = seriesdata;
      if (this.innerCircleName) {
        const component = this;
        this.seriesdata.unshift({
          name: this.innerCircleName,
          type: 'pie',
          data: [
            {
              name: this.innerCircleName,
              y: 0.0001,
              color: 'transparent',
              dataLabels: { enabled: false },
              events: {
                legendItemClick: function (this: any) {
                  const chart = component.chart as any;
                  if (!chart) return true;
                  const txt = chart._innerValueText;
                  if (!txt) return true;
                  // Read actual SVG state instead of relying on point.visible which can be undefined
                  const currentVis =
                    txt.element?.getAttribute('visibility') || 'visible';
                  const newVis = currentVis === 'hidden' ? 'visible' : 'hidden';
                  txt.attr({ visibility: newVis });
                  if (chart._innerSigText)
                    chart._innerSigText.attr({ visibility: newVis });
                  return true;
                },
              },
            },
          ],
          showInLegend: true,
          color: 'transparent',
          enableMouseTracking: false,
          dataLabels: { enabled: false },
        });
      }
    } else {
      // Limit number of slices to numberOfFunnelLevels (same property used by funnel chart for x-axis levels)
      const sliceLimit = this.chartproperties?.numberOfFunnelLevels;
      if (sliceLimit && sliceLimit > 0) {
        data = data.slice(0, sliceLimit);
      }
      let seriesdata: any[] = [];
      let d: any = {};
      let cov: any = [];
      let significance: any = [];
      let significance2: any = [];
      let samplesize: any = [];
      let label: any = [];
      let i = 0;
      d.animation = this.piechartservice.allowAnimation;
      d.zMin = 0; // ← ADD THIS
      //d.zMax = 100; // ← ADD THIS
      d.data = [];
      data.forEach((dat: any) => {
        cov.push(dat['Change value vs PY']);
        significance.push(dat['Significance']);
        significance2.push(dat['Significance2']);
        label.push(dat['Label']);
        samplesize.push(dat['Sample size']);
        d.name = dat['Category Name'];
        let value =
          isNaN(parseFloat(dat['Rounded Value'])) ||
          parseFloat(dat['Rounded Value']) == null
            ? null
            : Number(
                parseFloat(dat['Value']).toFixed(
                  this.chartproperties.decimalRoundOff,
                ),
              );
        let finalvalue = !islowsample
          ? value
          : parseFloat(dat['Sample size']) > this.samplesizeconstant
            ? value
            : 0;
        let m = {
          name: dat['Series Name'],
          y: finalvalue == null ? 0 : finalvalue,
          y1: finalvalue,
          actualcolor: this.seriescolor[i],
          color: !isgradient
            ? this.seriescolor[i++]
            : this.seriesgradientcolor[i++],
          //           z: parseFloat(dat['Rounded Value']),         // ← ADD HERE
          // zmax: parseFloat(dat['Rounded Value']) + 10,
          z: finalvalue ? finalvalue * 2 : 10,
          //zmax: 100,
          cov: dat['Change value vs PY'],
          significance: dat['Significance'],
          significance2: dat['Significance2'],
          samplesize: dat['Sample size'],
          tooltip: '',
        };
        d.data.push(m);
        this.datalength++;
      });
      seriesdata = [d];
      d = {};
      this.cov = cov;
      this.significance = significance;
      this.significance2 = significance2;
      this.label = label;
      this.samplesize = samplesize;
      this.seriesdata = seriesdata;
    }
  }
  private getResponsiveChartProps(): {
    center: [string, string | number];
    size: string;
    innerSize: string;
    fontSize: string;
    labelDistance: number;
    connectorWidth: number;
  } {
    const containerElement = document.getElementById(
      'chart-container' + this.id,
    );
    const insightsOpen = this.insightsOpen;

    // If popup is true, use fixed properties
    if (this.popUp && !this.chartproperties?.showLegend) {
      return {
        center: ['50%', '50%'],
        size: '90%',
        innerSize: '40%',
        fontSize: '0.9rem',
        labelDistance: -20,
        connectorWidth: 2,
      };
    }

    if (!containerElement) {
      return {
        center: ['50%', insightsOpen ? '50%' : '40%'],
        size: '75%',
        innerSize: '45%',
        fontSize: '0.8rem',
        labelDistance: -20,
        connectorWidth: 1,
      };
    }

    const containerWidth = containerElement.offsetWidth;
    const containerHeight = containerElement.offsetHeight;
    const minDimension = Math.min(containerWidth, containerHeight);

    // Helper to compute vertical center based on legend and insights
    const computeY = (baseYBottom: string, baseYSide: string): string => {
      if (insightsOpen) return '50%';
      return this.chartproperties?.legendPosition === 'bottom'
        ? baseYBottom
        : baseYSide;
    };

    // 📱 Mobile/Small screens (< 400px)
    if (minDimension < 260) {
      return {
        center: [
          this.chartproperties?.legendPosition === 'left'
            ? '75%'
            : this.chartproperties?.legendPosition === 'right'
              ? '23%'
              : this.chartproperties?.legendPosition === 'bottom'
                ? this.popUp
                  ? '50%'
                  : '50%'
                : '50%',
          this.chartproperties?.legendPosition === 'bottom'
            ? this.popUp
              ? '43%'
              : '20%'
            : '35%',
        ],
        size: this.chartproperties?.showLegend
          ? !this.popUp
            ? this.chartproperties?.legendPosition === 'bottom'
              ? '50%'
              : '65%'
            : '65%'
          : '70%',
        innerSize: this.popUp ? '90%' : '35%',
        fontSize: '0.7rem',
        labelDistance: -20,
        connectorWidth: 1,
      };
    }
    if (minDimension < 400) {
      return {
        center: [
          this.chartproperties?.legendPosition === 'left'
            ? '75%'
            : this.chartproperties?.legendPosition === 'right'
              ? this.popUp
                ? '35%'
                : '25%'
              : this.chartproperties?.legendPosition === 'bottom'
                ? this.popUp
                  ? '50%'
                  : '50%'
                : '50%',
          this.chartproperties?.legendPosition === 'bottom'
            ? this.popUp
              ? '43%'
              : '20%'
            : this.popUp
              ? '50%'
              : '35%',
        ],
        size: this.chartproperties?.showLegend
          ? !this.popUp
            ? this.chartproperties?.legendPosition === 'bottom'
              ? '50%'
              : '65%'
            : '75%'
          : '70%',
        innerSize: this.popUp ? '40%' : '35%',
        fontSize: '0.7rem',
        labelDistance: -20,
        connectorWidth: 1,
      };
    }
    if (minDimension < 500) {
      return {
        center: [
          this.chartproperties?.legendPosition === 'left'
            ? this.popUp
              ? '65%'
              : '50%'
            : this.chartproperties?.legendPosition === 'right'
              ? this.popUp
                ? '35%'
                : '45%'
              : '50%',
          this.chartproperties?.legendPosition === 'bottom'
            ? this.popUp
              ? '40%'
              : '30%'
            : '60%',
        ],
        size: this.popUp
          ? '80%'
          : this.chartproperties?.showLegend
            ? '70%'
            : '75%',
        innerSize: '42%',
        fontSize: '0.8rem',
        labelDistance: -22,
        connectorWidth: 1,
      };
    }
    // 📱 Tablet/Medium screens (400-800px)
    if (minDimension < 800) {
      return {
        center: [
          this.chartproperties?.legendPosition === 'left'
            ? this.popUp
              ? '65%'
              : '50%'
            : this.chartproperties?.legendPosition === 'right'
              ? this.popUp
                ? '35%'
                : '50%'
              : '50%',
          this.chartproperties?.legendPosition === 'bottom'
            ? this.popUp
              ? '40%'
              : '30%'
            : '40%',
        ],
        size: this.popUp
          ? '80%'
          : this.chartproperties?.showLegend
            ? '70%'
            : '75%',
        innerSize: '42%',
        fontSize: '0.8rem',
        labelDistance: -22,
        connectorWidth: 1,
      };
    }

    // 🖥️ Desktop/Large screens (800px+)
    return {
      center: [
        this.chartproperties?.legendPosition === 'left'
          ? '60%'
          : this.chartproperties?.legendPosition === 'right'
            ? '35%'
            : '50%',
        this.chartproperties?.legendPosition === 'bottom' ? '50%' : '40%',
      ],
      size: this.chartproperties?.showLegend
        ? insightsOpen
          ? '60%'
          : '55%'
        : '65%',
      innerSize: insightsOpen ? '48%' : '45%',
      fontSize: '0.9rem',
      labelDistance: -25,
      connectorWidth: 2,
    };
  }
  private getLegendXPosition(chartproperties: any, popUp: boolean): number {
    const containerElement = document.getElementById(
      'chart-container' + this.id,
    );
    let minDimension = 800; // default for desktop
    if (containerElement) {
      const containerWidth = containerElement.offsetWidth;
      const containerHeight = containerElement.offsetHeight;
      minDimension = Math.min(containerWidth, containerHeight);
    }

    // Responsive logic based on minDimension
    if (popUp) {
      if (minDimension < 400) {
        if (chartproperties.legendPosition === 'right') return 0;
        if (chartproperties.legendPosition === 'left') return 5;
        return 0;
      }
      if (minDimension < 500) {
        if (chartproperties.legendPosition === 'right') return 5;
        if (chartproperties.legendPosition === 'left') return 40;
        return 0;
      }
      if (chartproperties.legendPosition === 'right') return 10;
      if (chartproperties.legendPosition === 'left') return 15;
      return 0;
    } else {
      if (minDimension < 220) {
        if (chartproperties.legendPosition === 'right') return 110;
        if (chartproperties.legendPosition === 'left') return 120;
        return 10;
      }
      if (minDimension < 240) {
        if (chartproperties.legendPosition === 'right') return 90;
        if (chartproperties.legendPosition === 'left') return -10;
        return 10;
      }
      if (minDimension < 280) {
        if (chartproperties.legendPosition === 'right') return 30;
        if (chartproperties.legendPosition === 'left') return -10;
        return 10;
      }

      if (minDimension < 400) {
        if (chartproperties.legendPosition === 'right') return 60;
        if (chartproperties.legendPosition === 'left') return 120;
        return 10;
      }
      if (minDimension < 500) {
        if (chartproperties.legendPosition === 'right') return 80;
        if (chartproperties.legendPosition === 'left') return -10;
        return 15;
      }
      if (minDimension < 800) {
        if (chartproperties.legendPosition === 'right') return 20;
        if (chartproperties.legendPosition === 'left') return 150;
        return 20;
      }
      // Desktop/Large screens
      if (chartproperties.legendPosition === 'right') return 120;
      if (chartproperties.legendPosition === 'left') return -10;
      return 20;
    }
  }
  private getLegendItemWidth(chartproperties: any, popUp: boolean): number {
    const containerElement = document.getElementById(
      'chart-container' + this.id,
    );
    let minDimension = 800; // default for desktop
    if (containerElement) {
      const containerWidth = containerElement.offsetWidth;
      const containerHeight = containerElement.offsetHeight;
      minDimension = Math.min(containerWidth, containerHeight);
    }

    // Responsive logic based on minDimension
    if (popUp) {
      if (minDimension < 400) {
        return 380;
      }
      if (minDimension < 500) {
        return 520;
      }
      return 620;
    } else {
      if (minDimension < 400) {
        if (chartproperties.legendPosition === 'bottom') return 120;
        if (chartproperties.legendPosition === 'left') return 200;
        return 250;
      }
      if (minDimension < 500) {
        if (chartproperties.legendPosition === 'bottom') return 160;
        if (chartproperties.legendPosition === 'left') return 180;
        return 100;
      }
      if (minDimension < 800) {
        if (chartproperties.legendPosition === 'bottom') return 200;
        if (chartproperties.legendPosition === 'left') return 220;
        return 400;
      }
      // Desktop/Large screens
      if (chartproperties.legendPosition === 'bottom') return 200;
      if (chartproperties.legendPosition === 'left') return 220;
      return 250;
    }
  }

  seriesdata: any;
  cov: any;
  significance: any;
  samplesize: any;
  label: any;
  datalength: number = 0;
  // preparechartdata(data: any,islowsample:boolean,isgradient:boolean) {
  //   let seriesdata: any[] = [];
  //   let d: any = {};
  //   let cov: any = [];
  //   let significance: any = [];
  //   let samplesize:any=[];
  //   let label: any = [];
  //   let i = 0;
  //   d.animation=this.piechartservice.allowAnimation;
  //   d.data = [];
  //   data.forEach((dat: any) => {
  //     cov.push(dat['Change value vs PY']);
  //     significance.push(dat['Significance']);
  //     samplesize.push(dat['Sample size']);
  //     label.push(dat['Label']);
  //     d.name = dat['Category Name'];
  //     let value=isNaN(parseFloat(dat['Value']))||parseFloat(dat['Value'])==null?null:parseFloat(Number(parseFloat(dat['Value'])).toFixed(this.chartproperties.decimalRoundOff))
  //     let finalvalue=!islowsample?value:(parseFloat(dat['Sample size'])>this.samplesizeconstant?value:0)
  //     let m = {
  //       name: dat['Series Name'],
  //       y: finalvalue==null?0:finalvalue,
  //       y1:finalvalue,
  //       actualcolor:this.seriescolor[i],
  //       color: !isgradient?this.seriescolor[i++]:this.seriesgradientcolor[i++],
  //       z: parseFloat(dat['Rounded Value']),
  //       zmax: parseFloat(dat['Rounded Value']) + 10,
  //       cov:dat['Change value vs PY'],
  //       significance:dat['Significance'],
  //       significance2:dat['Significance2'],
  //       samplesize:dat['Sample size'],
  //       tooltip:""
  //     };
  //     d.data.push(m);
  //     this.datalength++;
  //   });
  //   seriesdata = [d];
  //   d = {};
  //   this.cov = cov;
  //   this.significance = significance;
  //   this.samplesize=samplesize;
  //   this.label = label;
  //   this.seriesdata = seriesdata;
  // }
  chart: any;
  plotChart(
    containerId: any,
    jsondata: any,
    chartproperties: any,
    cohortData?: any,
  ) {
    localStorage.setItem('properties', JSON.stringify(this.chartproperties));
    HC_accessibility(Highcharts);
    variablePie(Highcharts);
    let c = 0;
    let chartimagepath = this.chartimagepath;
    let samplesizeconstant = this.samplesizeconstant;
    // For multi-cohort, multi-brand, or multiPropellerPopup, hide legend on individual charts (shared legend used instead)
    const showLegendForChart =
      this.isMultiCohort || this.isMultiBrand || this.multiPropellerPopup
        ? false
        : chartproperties.showLegend;
    const self = this;
    //this.preparechartdata(jsondata,chartproperties.datalabelStyle=='ls',chartproperties.gradientBarColor);
    if (this.isOutput) {
      const dataToUse = cohortData ? cohortData : this.customData;
      const innerMetricObj = this.innerMetricObj ?? null;
      const innerDataArray = innerMetricObj?.metric_value?.[0]?.data;
      // For multiPropellerPopup each instance represents a specific brand — find that brand's data.
      // Fall back to [0] if no match (e.g. single-brand mode).
      const innerData = this.selectedBrand
        ? (innerDataArray?.find(
            (d: any) => d.colChild === this.selectedBrand,
          ) ?? innerDataArray?.[0])
        : innerDataArray?.[0];
      const rawVal = innerData?.data;
      const covVal =
        innerData?.changeVsPY_Total ?? innerData?.changeVsPY_Answer;
      const sigVal = innerData?.Significance_Value;
      const isMean = innerData?.CalculationType?.toLowerCase() === 'mean';
      // debugger;
      const self = this;
      const indexVal = innerData?.data2;
      if (
        this._configService.isIndexSelected &&
        indexVal != null &&
        indexVal !== -9999
      ) {
        // const percentVal = rawVal != null ? isMean
        //   ? (rawVal * 100).toFixed(this.chartproperties?.decimalRoundOff ?? 2) + '%'
        //   : null;
        const percentVal =
          rawVal != null
            ? isMean
              ? Number(rawVal).toFixed(
                  this.chartproperties?.decimalRoundOff ?? 2,
                )
              : (rawVal * 100).toFixed(
                  this.chartproperties?.decimalRoundOff ?? 2,
                ) + '%'
            : null;

        const idxNum = parseFloat(Number(indexVal).toFixed(1));
        const idxColor = idxNum > 120 ? 'green' : idxNum < 80 ? 'red' : 'black';
        this.innerCircleDisplayValue = percentVal;
        this.innerCircleSigText = `(${idxNum})`;
        this.innerCircleSigColor = idxColor;
      } else {
        this.innerCircleDisplayValue =
          rawVal != null
            ? isMean
              ? Number(rawVal).toFixed(
                  this.chartproperties?.decimalRoundOff ?? 2,
                )
              : (rawVal * 100).toFixed(
                  this.chartproperties?.decimalRoundOff ?? 2,
                ) + '%'
            : null;
        //this.innerCircleDisplayValue = rawVal != null ? (rawVal * 100).toFixed(this.chartproperties?.decimalRoundOff ?? 2) + '%' : null;
        if (chartproperties.datalabelStyle === 'sigChange' && covVal != null) {
          const isPercentage =
            innerData?.CalculationType?.toLowerCase() === 'share';
          const changeVal = isPercentage
            ? Number(covVal) * 100
            : Number(covVal);
          const sigClass =
            sigVal < this.Sig_LowerLimt
              ? 'red'
              : sigVal > this.Sig_UpperLimt
                ? 'green'
                : 'black';
          this.innerCircleSigText = `(${Math.round(changeVal)}${isPercentage ? '%' : ''})`;
          this.innerCircleSigColor = sigClass;
        } else {
          this.innerCircleSigText = null;
          this.innerCircleSigColor = 'black';
        }
      }
      this.innerCircleLabel = innerMetricObj?.metric_option ?? null;
      this.preparemainChartData(dataToUse);

      this.chartMainData = this.chartMainData.filter(
        (item: any) => item['Label'] !== 'NA' && item['Label'] !== null,
      );
      this.preparechartdata(
        this.chartMainData,
        chartproperties.datalabelStyle == 'ls',
        chartproperties.gradientBarColor,
      );
    } else {
      this.preparechartdata(
        jsondata,
        chartproperties.datalabelStyle == 'ls',
        chartproperties.gradientBarColor,
      );
      // console.log('NON-OUTPUT seriesdata:', JSON.stringify(this.seriesdata[0].data));
      // console.log('NON-OUTPUT mode');
      // console.log('jsondata:', jsondata);
      // console.log('seriesdata:', this.seriesdata);
      // console.log('containerId:', containerId);
      // console.log('containerEl:', document.getElementById(containerId));
    }
    const containerEl = document.getElementById(containerId);
    if (!containerEl) {
      return;
    }

    const dataSeriesIndex = this.innerCircleName ? 1 : 0;
    if (!this.seriesdata || !this.seriesdata[dataSeriesIndex]?.data?.length) {
      containerEl.innerHTML =
        '<div style="display:flex; align-items:center; justify-content:center; height:100%; min-height:100px; font-size: 0.7rem; font-family:KantarBrown-Regular,sans-serif;">Not Applicable</div>';
      return;
    }
    // ADD THIS
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }

    const responsive = this.getResponsiveChartProps();
    //debugger;
    this.chart = Highcharts.chart(containerEl, {
      accessibility: {
        point: {
          valueSuffix: '%',
        },
      },
      chart: {
        //marginTop: 30,
        marginTop: 10,
        type: 'variablepie',
        contextMenu: false,
        backgroundColor: chartproperties.darkTheme ? '#333' : 'white',
        events: {
          render: function () {
            const chart = this as any;

            // Check if the image is already rendered
            // if (!chart.groupImage) {
            //   let imageUrl = chartimagepath;
            // Skip center image rendering for propeller chart (keep donut clean)
            if (!chart.groupImage && chartimagepath && false) {
              let imageUrl = chartimagepath;

              // Render the image if it doesn't exist
              chart.groupImage = chart.renderer
                .image(
                  imageUrl,

                  chart.plotLeft + chart.plotWidth / 2 - 50 / 2, // X position calculation
                  chart.plotTop + chart.plotHeight / 2 - 50 / 2, // Y position calculation
                  50,
                  50,
                )
                .attr({
                  zIndex: 6,
                  display: 'none',
                })
                .add();
            }

            // Check if the separator line is already rendered
            if (!chart.separatorLine) {
              chart.separatorLine = []; // Initialize an array to store the lines

              var series = chart.series[0];
              for (let i = 0; i < series.points.length; i++) {
                var point = series.points[i];
                var endAngle = point.shapeArgs.end;
                var centerX = chart.plotWidth / 2 + 10;
                var centerY = chart.plotHeight / 2 + 50;
                var radius =
                  Math.min(chart.plotWidth, chart.plotHeight) / 2 + 8;

                var endX = centerX + radius * Math.cos(endAngle);
                var endY = centerY + radius * Math.sin(endAngle);

                // Draw the line at the end position of the pie slice
                let separatorLine = chart.renderer
                  .path(['M', centerX, centerY, 'L', endX, endY])
                  .attr({
                    'stroke-width': 2,
                    stroke: chartproperties.darkTheme ? 'white' : '#333',
                    display: 'none',
                    //display: chartproperties.separator ? 'block' : 'none',
                  })
                  .add();

                chart.separatorLine.push(separatorLine); // Store the line in the array
              }
            }

            // Check if the separator circle is already rendered
            if (!chart.separatorCircle) {
              // Render the separator circle if it doesn't exist
              let centerX1 = chart.plotLeft + chart.plotWidth * 0.5,
                centerY1 = chart.plotTop + chart.plotHeight * 0.5,
                radius1 = Math.min(chart.plotWidth, chart.plotHeight) * 0.27;
              chart.separatorCircle = chart.renderer
                .circle(centerX1, centerY1, radius1)
                .attr({
                  fill: chartproperties.darkTheme ? '#333' : 'white',
                  display: chartproperties.separator ? 'block' : 'none',
                })
                .add();
            }

            if (!chart.innerBorderCircle) {
              const borderWidth = 2;
              const borderColor = chartproperties.darkTheme ? '#666' : '#ccc';
              const _bsi = self.innerCircleName ? 1 : 0;
              const _bseries = chart.series[_bsi];
              // Use actual series center and inner radius so the ring stays aligned
              // regardless of responsive.size (e.g. '55%' for legend-left).
              // series.center = [cx, cy, outerDiameter, innerDiameter] (plot-relative px)
              const centerX2 =
                _bseries?.center != null
                  ? _bseries.center[0] + chart.plotLeft
                  : chart.plotLeft + chart.plotWidth / 2;
              const centerY2 =
                _bseries?.center != null
                  ? _bseries.center[1] + chart.plotTop
                  : chart.plotTop + chart.plotHeight / 2;
              const circleRadius =
                _bseries?.center?.[3] != null
                  ? _bseries.center[3] / 2 // center[3] = inner diameter
                  : Math.min(chart.plotWidth, chart.plotHeight) * 0.165;

              chart.innerBorderCircle = chart.renderer
                .circle(centerX2, centerY2, circleRadius)
                .attr({
                  fill: 'none',
                  'stroke-width': borderWidth,
                  stroke: borderColor,
                  dashstyle: 'Dash',
                  visibility: chartproperties.fixedCircleRadius
                    ? 'visible'
                    : 'hidden',
                })
                .add();
            }

            // Function to update the position of elements
            function updatePosition() {
              if (chart.groupImage) {
                chart.groupImage.attr({
                  x: chart.plotLeft + chart.plotWidth / 2 - 50 / 2,
                  y: chart.plotTop + chart.plotHeight / 2 - 50 / 2,
                });
              }

              if (chart.separatorCircle) {
                chart.separatorCircle.attr({
                  cx: chart.plotLeft + chart.plotWidth * 0.5,
                  cy: chart.plotTop + chart.plotHeight * 0.5,
                });
              }

              if (chart.innerBorderCircle) {
                const _usi = self.innerCircleName ? 1 : 0;
                const _us = chart.series[_usi];
                const _ucx =
                  _us?.center != null
                    ? _us.center[0] + chart.plotLeft
                    : chart.plotLeft + chart.plotWidth / 2;
                const _ucy =
                  _us?.center != null
                    ? _us.center[1] + chart.plotTop
                    : chart.plotTop + chart.plotHeight / 2;
                // Store so the inner-circle display value text (rendered in setTimeout) uses the same position
                chart._pieCenterX = _ucx;
                chart._pieCenterY = _ucy;
                const _uattrs: any = {
                  cx: _ucx,
                  cy: _ucy,
                  visibility: chartproperties.fixedCircleRadius
                    ? 'visible'
                    : 'hidden',
                };
                if (_us?.center?.[3] != null) {
                  _uattrs.r = _us.center[3] / 2;
                }
                chart.innerBorderCircle.attr(_uattrs);
              }
              // Dynamically reposition inner circle metric text to stay centered
              if (chart._innerValueText || chart._innerSigText) {
                const _tsi = self.innerCircleName ? 1 : 0;
                const _ts = chart.series[_tsi];
                const _tcx =
                  _ts?.center != null
                    ? _ts.center[0] + chart.plotLeft
                    : chart.plotLeft + chart.plotWidth / 2;
                const _tcy =
                  _ts?.center != null
                    ? _ts.center[1] + chart.plotTop
                    : chart.plotTop + chart.plotHeight / 2;
                if (chart._innerValueText) {
                  chart._innerValueText.attr({
                    x: _tcx,
                    y: chart._innerSigText ? _tcy - 6 : _tcy,
                  });
                }
                if (chart._innerSigText) {
                  chart._innerSigText.attr({
                    x: _tcx,
                    y: _tcy + 10,
                  });
                }
              }

              // if (chart.innerBorderCircle) {
              //   console.log('Updating innerBorderCircle visibility:', chartproperties.fixedCircleRadius ? 'visible' : 'hidden');
              //   chart.innerBorderCircle.attr({
              //     cx: chart.plotLeft + (chart.plotWidth / 2) ,
              //     cy: chart.plotTop + (chart.plotHeight / 2) - 3,
              //     visibility: chartproperties.fixedCircleRadius ? 'visible' : 'hidden',
              //   });
              // }

              // Update the position of separator lines
              if (chart.separatorLine) {
                var series = chart.series[0];
                for (let i = 0; i < series.points.length; i++) {
                  var point = series.points[i];
                  var endAngle = point.shapeArgs.end;
                  var centerX = chart.plotWidth / 2 + 10;
                  var centerY = chart.plotHeight / 2 + 50;
                  var radius = Math.min(chart.plotWidth, chart.plotHeight) / 2;

                  var endX = centerX + radius * Math.cos(endAngle);
                  var endY = centerY + radius * Math.sin(endAngle);

                  // Update the position of the separator line
                  chart.separatorLine[i].attr({
                    d: ['M', centerX, centerY, 'L', endX, endY],
                    'stroke-width': 2,
                    stroke: chartproperties.darkTheme ? 'white' : '#333',
                    //display: chartproperties.separator ? 'block' : 'none',
                    display: 'none',
                  });
                }
              }

              // Call the function on the next animation frame
              requestAnimationFrame(updatePosition);
            }

            // Initial call to start the animation
            updatePosition();
          },
        },
        style: {
          fontFamily: this.piechartservice.fontFamily,
        },
      },
      title: {
        text: '',
        align: chartproperties.chartTitlePosition,
        verticalAlign: 'top',
        style: {
          color: chartproperties.darkTheme ? 'white' : 'black',
          fontSize: '2em',
        },
      },
      legend: {
        navigation: {
          itemMarginLeft: 10,
          activeColor: '#7f7f7f',
          animation: true,
          arrowSize: 10,
          inactiveColor: '#ccc',
          style: {
            fontSize: '0.7em',
            color: chartproperties.darkTheme ? 'white' : '#333',
          },
        },
        //itemMarginBottom: 10,
        itemMarginBottom: 5,
        enabled: showLegendForChart,
        // y:chartproperties.legendPosition == 'bottom'?25:0,
        // maxHeight:  chartproperties.legendPosition == 'bottom'?40:300,
        y: chartproperties.legendPosition == 'bottom' ? -50 : -30,
        //y:chartproperties.legendPosition == 'bottom'?-35:-30,
        maxHeight: chartproperties.legendPosition == 'bottom' ? 60 : 200,
        layout:
          chartproperties.legendPosition != 'bottom'
            ? 'vertical'
            : 'horizontal',
        //align: chartproperties.legendPosition,

        align:
          chartproperties.legendPosition == 'bottom'
            ? 'center'
            : chartproperties.legendPosition,

        verticalAlign:
          chartproperties.legendPosition != 'bottom' ? 'middle' : 'bottom',

        useHTML: true,
        // symbolWidth: chartproperties.legendStyle == 'default'?12:-1,
        // symbolRadius: chartproperties.legendStyle == 'default'?0:-1,
        // symbolHeight:chartproperties.legendStyle == 'default'?12:-1,
        symbolWidth: -1,
        symbolRadius: -1,
        symbolHeight: -1,
        itemStyle: {
          fontWeight: 'normal',
          fontSize: '0.8em',
        },
        labelFormatter: function (this: Highcharts.Point): any {
          let textcolor = chartproperties.darkTheme ? 'white' : 'black';
          if (chartproperties.legendStyle == 'default') {
            const dotColor =
              (this as any).legendkeycolor || (this as any).color || '#ccc';
            const isInnerMetric = (this as any).name === self.innerCircleName;
            return (
              '<div style="display:flex;align-items:center;font-size:0.8em;" title="' +
              (this as any).name +
              '">' +
              '<div style="flex:0 0 10px;width:10px;height:10px;' +
              (isInnerMetric
                ? 'background-color:white;border:1.5px solid #333;'
                : 'background-color:' + dotColor + ';') +
              'border-radius:50%;"></div>' +
              '<div style="font-size:0.8em;margin-left:6px;color:' +
              textcolor +
              ';">' +
              (this as any).name +
              '</div>' +
              '</div>'
            );
          }
          //           if (chartproperties.legendStyle == 'default') {
          //   return '<div style="display:flex;align-items:center;font-size:0.8em;" title="' + (this as any).name + '">'
          //     + '<div style="flex:0 0 10px;width:10px;height:10px;background-color:' + (this as any).legendkeycolor + ';border-radius:50%;"></div>'
          //     + '<div style="font-size:0.8em;margin-left:6px;color:' + textcolor + ';">' + (this as any).name + '</div>'
          //     + '</div>';
          // }
          // if (chartproperties.legendStyle == 'default') {
          //   return (
          //     '<span style="font-size:9.5px;font-size:1em; color: ' +
          //     textcolor +
          //     '">' +
          //     this.name +
          //     '</span>'
          //   );
          // }
          if (chartproperties.legendStyle == 'style1') {
            return (
              '<div class="container" style="display: flex; align-items: center;padding-bottom:20px">' +
              '<div class="content-wrapper" style="display: flex; align-items: center; position: relative;">' +
              '<div class="circle" style="width: 40px; height: 40px; border-radius: 50%; color: white; background-color:' +
              this.color +
              '; display: flex; justify-content: center; align-items: center; margin-right: auto;"><p style="padding-top:8px;">' +
              (this.y == null || this.y == 0 ? 'NA' : this.y + '%') +
              '</p></div>' +
              '<div class="rectangle" style="width: 90px; height: 20px; border: 1px solid ' +
              this.color +
              '; display: flex; justify-content: center; align-items: center; margin-left: -15px; border-radius: 20px;"><p style="color: ' +
              textcolor +
              ';padding-top:8px"">' +
              this.name +
              '</p></div>' +
              '</div>' +
              '</div>'
            );
          }
          if (chartproperties.legendStyle == 'style2') {
            return `
              <div style="display: flex; align-items: center;">
                <div style="flex: 1 1 auto; height: 1px; background: black;"></div>

                <div style="display: flex; flex-direction: column; align-items: center;">
                  <div style="width: 40px; height: 40px; border-radius: 50%; color: white; background-color: ${this.color}; display: flex; justify-content: center; align-items: center;">
                    <p style="padding-top:8px">${this.y == null || this.y == 0 ? 'NA' : this.y + '%'}</p>  
                  </div>

                  <div style="width: 100px; height: 20px; border: 1px solid ${this.color}; border-radius: 20px; display: flex; justify-content: center; align-items: center; margin-top: 5px;">
                    <p style="color:${textcolor};padding-top:8px">${this.name}</p>
                  </div>
                </div>

              </div>
            `;
          }
          if (chartproperties.legendStyle == 'style3') {
            return (
              '<div style="display:flex;margin-bottom:15px;align-items:center">' +
              '<div style="display:flex;width:10px;height:20px;background-color:' +
              this.color +
              '"></div>' +
              '<div style="display:flex;width:90px;height:20px;padding-left:10px;box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);color:' +
              textcolor +
              '">' +
              '   ' +
              this.name +
              '   ' +
              (this.y == null || this.y == 0 ? 'NA' : this.y + '%') +
              '</div>' +
              '</div>'
            );
          }
        },
      },
      tooltip: {
        enabled: true,
        borderWidth: 1,
        useHTML: true,
        shape: 'square',
        shadow: false,
        backgroundColor: 'white',
        outside: this.popUp ? false : true,
        style: {
          fontSize: '0.8rem',
        },
        formatter: function (this: any): any {
          const pointWithMetric = this.point as {
            name?: any;
            parent?: any;
            color?: any;
            actualcolor?: any;
            y?: number;
            y1?: number;
            cov?: string;
            significance?: string;
            significance2?: string;
            samplesize?: number;
            tooltip?: any;
            Significance_Value?: any;
          };
          if (
            pointWithMetric.color === '#eeebed' ||
            pointWithMetric.color === '#7f7f7f'
          ) {
            return false;
          }
          const backgroundcolor = chartproperties.darkTheme
            ? '#b3b3b3'
            : '#f5f5f5';
          const backgroundcolor2 = chartproperties.darkTheme
            ? '#dddddd'
            : 'white';
          if (pointWithMetric.tooltip == '') {
            pointWithMetric.tooltip =
              pointWithMetric.y1 == null ? 'NA' : pointWithMetric.y;
          }

          let isDefaultTooltip = chartproperties.toolTipStyle;
          if (isDefaultTooltip == 'style1') {
            const dotColor = pointWithMetric.actualcolor;
            this.point.series.tooltipOptions.borderColor = dotColor;
            this.point.series.tooltipOptions.borderWidth = 10;
            const content = `<div class="high-z-tooltip" style="background: #fff;  min-width: 20px; font-size: 0.8em; display: flex; box-shadow: none;align-items: center;z-index:999 !important;padding:2px;">
      <span style=" width:10px; height:10px; border-radius:50%; background:${dotColor}; margin-right:8px; vertical-align:middle;"></span>
      <span>${pointWithMetric.name}: </span>
      <b style="margin-left:4px;">${pointWithMetric.tooltip}</b>
    </div>`;
            return content;
            return content + '</div>';
          } else if (chartproperties.datalabelStyle === 'sigChange') {
          } else {
            const dotColor = pointWithMetric.actualcolor; // Get the series color

            const commonContent =
              `<div style="border-left: 2px solid ` +
              dotColor +
              `;font-size:0.7em; border-bottom: 2px solid ` +
              dotColor +
              `; z-index: 100; padding: 5px; border-radius: 5px; margin: 0px; background-color :${backgroundcolor2};">` +
              // `<span style="display: block; text-align: center; color: `+dotColor+`; font-weight: bold; font-size: 12px;">Tooltip Title</span>` +
              // `<span><strong>Series Name:</strong></span>Brands<br>` +
              ` ${pointWithMetric.name} : ` +
              `${pointWithMetric.tooltip}`;
            return commonContent + '</div>';
          }
        },

        //         formatter: function (this: any):any {
        //           const pointWithMetric = this.point as {
        //             name?:any;
        //             parent?:any;
        //             color?:any;
        //             actualcolor?:any;
        //             y?: number;
        //             y1?:number;
        //             cov?: string;
        //             significance?: string;
        //             significance2?: string;
        //             samplesize?: number;
        //             tooltip?:any
        //           };
        //           console.log('=== FORMATTER DEBUG ===');
        // console.log('datalabelStyle in formatter:', chartproperties.datalabelStyle);
        // console.log('Significance_Value:', (pointWithMetric as any).Significance_Value);
        // console.log('Sig_LowerLimt:', (pointWithMetric as any).Sig_LowerLimt);
        // console.log('Sig_UpperLimt:', (pointWithMetric as any).Sig_UpperLimt);
        // console.log('cov:', pointWithMetric.cov);
        // console.log('isPercentage:', (pointWithMetric as any).isPercentage);
        // console.log('y:', pointWithMetric.y);
        // console.log('y1:', pointWithMetric.y1);
        //           const backgroundcolor = chartproperties.darkTheme ? '#b3b3b3' : '#f5f5f5';
        //           const backgroundcolor2 = chartproperties.darkTheme ? '#dddddd' : 'white';
        //           if(pointWithMetric.tooltip==""){pointWithMetric.tooltip=pointWithMetric.y1==null?'NA':pointWithMetric.y}

        //           let isDefaultTooltip = chartproperties.toolTipStyle;
        //           if (isDefaultTooltip == "style1") {
        //             const dotColor = pointWithMetric.actualcolor;
        //             const commonContent =
        //               `<div style="border-left: 5px solid `+dotColor+`; border-bottom: 5px solid `+dotColor+`; z-index: 100; padding: 5px; border-radius: 5px; margin: 0px; background-color :${backgroundcolor2};">` +
        //               `<span style="display: block; text-align: center; color: `+dotColor+`; font-weight: bold; font-size: 12px;">Tooltip Title</span>` +
        //               `<span><strong>Series Name:</strong></span>Brands<br>` +
        //               `<span><strong>Category Name:</strong></span> ${pointWithMetric.name}<br>` +
        //               `<span><strong>Value:</strong></span> ${pointWithMetric.tooltip}`;
        //             return commonContent + '</div>';
        //           }
        //           else {
        //             const dotColor = pointWithMetric.actualcolor; // Get the series color

        //             const content =
        //               `<div style="background-color: ${backgroundcolor}; padding: 5px; align-items: center; border: 1px solid ${dotColor}; ">` +
        //               `<div style="width: 10px; height: 10px; background-color: ${dotColor}; border-radius: 50%; margin-right: 5px;"><div style="padding-left:10px;margin-top:0">${pointWithMetric.name}</div></div>`  +
        //               `<div style="display: block; margin-top: 5px;"><strong>Value:</strong> ${pointWithMetric.tooltip}</div>`;

        //             return content + '</div>';

        //           }

        //         },
      },
      plotOptions: {
        variablepie: {
          //  size: '95%',        // ← fixed value
          //     center: ['50%', '50%'],
          size: this.multiPropellerPopup
            ? '85%'
            : chartproperties.legendPosition === 'left' ||
                chartproperties.legendPosition === 'right'
              ? responsive.size
              : '95%',
          center: this.multiPropellerPopup
            ? ['50%', '50%']
            : chartproperties.legendPosition === 'left' ||
                chartproperties.legendPosition === 'right'
              ? responsive.center
              : ['50%', '50%'],

          showInLegend: showLegendForChart,
          borderWidth: 3, // ← change from chartproperties.border?2:0
          borderColor: 'white',
          //innerSize: 170,
          innerSize: '33%',
          depth: 1,
          shadow: chartproperties.shadow
            ? {
                color: chartproperties.darkTheme
                  ? 'white'
                  : 'rgba(0, 0, 0, 0.5)',
                offsetX: 1,
                offsetY: 1,
                opacity: 0.5,
                width: 6,
              }
            : false,
          dataLabels: {
            style: {
              textOutline: 'none',
              fontSize: chartproperties.dataLabelSize,
              //fontSize: '0.6em',
              fontWeight: 'normal',
            },
            enabled: chartproperties.showDataLabel,
            color:
              chartproperties.dataLabelColor == 'default'
                ? chartproperties.darkTheme
                  ? 'white'
                  : 'black'
                : chartproperties.dataLabelColor,
            //connectorWidth: chartproperties.connector ? 1 : -0,
            // connectorWidth: 1,
            // connectorColor:  '#333',
            // connectorPadding: 5,
            distance: this.multiPropellerPopup ? 18 : 10,
            connectorWidth: this.multiPropellerPopup ? 1 : 1,
            connectorColor: null,
            connectorPadding: 2,
            allowOverlap: false, // ← ADD THIS - prevents overlapping
            crop: false, // ← ADD THIS
            overflow: 'allow',
            //distance: chartproperties.connector ? 10 : 0,
            //distance:29,
            useHtml: true,
            formatter: function (
              this: Highcharts.TooltipFormatterContextObject,
            ): any {
              const pointWithMetric = this.point as {
                name?: any;
                parent?: any;
                color?: any;
                y?: number;
                y1?: number;
                cov?: string;
                significance?: string;
                samplesize?: number;
                significance2?: any;
                tooltip?: any;
                isPercentage?: any;
                Sig_LowerLimt?: any;
                Sig_UpperLimt?: any;
                Significance_Value?: any;
              };

              let textcolor = chartproperties.darkTheme ? 'white' : 'black';
              // if (chartproperties.datalabelStyle === 'datalabel') {
              //   let text=pointWithMetric.y1!=null?pointWithMetric.y+(chartproperties.dataLabelFormat?'%':''):"NA";
              //   pointWithMetric.tooltip=text;
              //   return (
              //     '<span style="display: inline-block;padding:3px;">' +
              //     text +
              //     '</span>'
              //   );
              // }
              if (chartproperties.datalabelStyle === 'datalabel') {
                chartproperties.dataLabelFormat = (
                  pointWithMetric as any
                ).isPercentage;
                let text =
                  pointWithMetric.y1 != null
                    ? pointWithMetric.y +
                      (chartproperties.dataLabelFormat ? '%' : '')
                    : 'NA';
                pointWithMetric.tooltip = text;
                return (
                  '<span style="display: inline-block;padding:3px;">' +
                  text +
                  '</span>'
                );
              } else if (chartproperties.datalabelStyle === 'index') {
                chartproperties.dataLabelFormat = (
                  pointWithMetric as any
                ).isPercentage;
                let text =
                  pointWithMetric.y1 != null
                    ? pointWithMetric.y +
                      (chartproperties.dataLabelFormat ? '%' : '')
                    : 'NA';

                let text2: any =
                  (pointWithMetric as any).actualIndexValue == null
                    ? 'NA'
                    : (pointWithMetric as any).y1 == -1
                      ? -1
                      : pointWithMetric.y1 != null
                        ? (pointWithMetric as any).indexValue?.toFixed(1)
                        : 'NA';

                if (text2 == '-1' || text2 == -1) {
                  text2 = 'NA';
                }

                let color =
                  text2 == 'NA'
                    ? 'black'
                    : Number(text2) > 100
                      ? 'green'
                      : Number(text2) < 100
                        ? 'red'
                        : 'black';
                pointWithMetric.tooltip = text + '(' + text2 + ')';
                return (
                  '<span style="font-size:0.5rem;color:' +
                  textcolor +
                  ';">' +
                  text +
                  ' ' +
                  '(<span style="color:' +
                  color +
                  ';font-size:0.45rem;">' +
                  text2 +
                  '</span>)' +
                  '</span>'
                );
              } else if (chartproperties.datalabelStyle === 'sigChange') {
                chartproperties.dataLabelFormat = (
                  pointWithMetric as any
                ).isPercentage;
                let textCheck = (pointWithMetric as any).samplesize;
                let changeVal = (pointWithMetric as any).isPercentage
                  ? Number(pointWithMetric.cov) * 100
                  : Number(pointWithMetric.cov);
                if (
                  pointWithMetric.cov == null ||
                  pointWithMetric.cov == 'NA'
                ) {
                  let text =
                    pointWithMetric.y +
                    (chartproperties.dataLabelFormat ? '%' : '') +
                    ' ' +
                    `<span style="font-size: 80%;color:black;">(${'NA'})</span>`;
                  pointWithMetric.tooltip = text;
                  return (
                    '<span style="color:' +
                    textcolor +
                    ';font-size:' +
                    chartproperties.dataLabelSize +
                    '">' +
                    text +
                    '</span>'
                  );
                } else {
                  let sigClass =
                    (pointWithMetric as any).Significance_Value <
                    (pointWithMetric as any).Sig_LowerLimt
                      ? 'red'
                      : (pointWithMetric as any).Significance_Value >
                          (pointWithMetric as any).Sig_UpperLimt
                        ? 'green'
                        : 'black';
                  let text =
                    pointWithMetric.y +
                    (chartproperties.dataLabelFormat ? '%' : '') +
                    ' ' +
                    (`<br><span style="font-size: 80%; color: ${sigClass};">(` +
                      `${pointWithMetric.cov != null ? roundChangeText(changeVal) + (chartproperties.dataLabelFormat ? '%' : '') : 'NA'})</span>`);
                  pointWithMetric.tooltip = text;
                  return (
                    '<span style="color:' +
                    textcolor +
                    ';font-size:' +
                    chartproperties.dataLabelSize +
                    '">' +
                    text +
                    '</span>'
                  );
                }
              } else if (chartproperties.datalabelStyle === 'bubble') {
                return (
                  '<div style="text-align:center;border-top: 5px solid ' +
                  pointWithMetric.color +
                  ';background-color:white;position: relative;max-width:50px;max-height:40px;box-shadow:0px 5px 20px 5px #333;">' +
                  '<span style="display: inline-block;padding:3px;color:' +
                  pointWithMetric.color +
                  '">' +
                  (pointWithMetric.y1 == null
                    ? 'NA'
                    : pointWithMetric.y +
                      (chartproperties.dataLabelFormat ? '%' : '')) +
                  '</span>' +
                  '</div>'
                );
              } else if (chartproperties.datalabelStyle === 'change') {
                let text =
                  pointWithMetric.y1 != null
                    ? pointWithMetric.y +
                      (chartproperties.dataLabelFormat ? '%' : '') +
                      ' ' +
                      `<span span style="font-size: 80%;color:` +
                      (chartproperties.darkTheme ? 'white' : 'black') +
                      `">(` +
                      (Number(pointWithMetric.cov) > 0 ? '+' : '') +
                      `${pointWithMetric.cov} )</span>`
                    : 'NA';
                pointWithMetric.tooltip = text;
                return (
                  '<span style:"color:' + textcolor + ';">' + text + '</span>'
                );
              } else if (
                chartproperties.datalabelStyle === 'significance + changeVs'
              ) {
                const upwardTriangle = '\u25B2';
                const downwardTriangle = '\u25BC';
                let sig = Number(pointWithMetric.significance);
                let s =
                  sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
                let text =
                  pointWithMetric.y1 != null
                    ? pointWithMetric.y +
                      (chartproperties.dataLabelFormat ? '%' : '') +
                      ' ' +
                      `<span span style="font-size: 80%;color:` +
                      (chartproperties.darkTheme ? 'white' : 'black') +
                      `">(` +
                      (Number(pointWithMetric.cov) > 0 ? '+' : '') +
                      `${pointWithMetric.cov} )</span>` +
                      '<span style="color:' +
                      sigcolor +
                      ';">' +
                      s +
                      '</span>'
                    : 'NA';
                pointWithMetric.tooltip = text;
                return (
                  '<span style:"color:' + textcolor + ';">' + text + '</span>'
                );
              } else if (chartproperties.datalabelStyle === 'significance') {
                const upwardTriangle = '\u25B2';
                const downwardTriangle = '\u25BC';
                let sig = Number(pointWithMetric.significance);
                let s =
                  sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
                let text =
                  pointWithMetric.y1 != null
                    ? pointWithMetric.y +
                      (chartproperties.dataLabelFormat ? '%' : '') +
                      '<span style="color:' +
                      sigcolor +
                      ';">' +
                      s +
                      '</span>'
                    : 'NA';
                pointWithMetric.tooltip = text;
                return (
                  '<span style:"color:' + textcolor + ';">' + text + '</span>'
                );
              } else if (chartproperties.datalabelStyle === 'ls') {
                let text =
                  Number(pointWithMetric.samplesize) > samplesizeconstant
                    ? pointWithMetric.y1 == null || pointWithMetric.y == 0
                      ? 'NA'
                      : pointWithMetric.y +
                        (chartproperties.dataLabelFormat ? '%' : '')
                    : 'LS';
                return (
                  '<span style="display: inline-block;padding:3px;">' +
                  text +
                  '</span>'
                );
                pointWithMetric.tooltip = text;
              } else if (chartproperties.datalabelStyle == 'significance2') {
                const upwardTriangle = '\u25B2';
                const downwardTriangle = '\u25BC';
                let text =
                  pointWithMetric.y1 != null
                    ? this.y + (chartproperties.dataLabelFormat ? '%' : '')
                    : 'NA';
                let changeText = roundChangeText(pointWithMetric.cov);
                let sig = pointWithMetric.significance;
                let sig1 = pointWithMetric.significance2;
                let sColor =
                  Number(sig) > 0 ? 'green' : Number(sig) < 0 ? 'red' : '';
                let s =
                  Number(sig) > 0
                    ? upwardTriangle
                    : Number(sig) < 0
                      ? downwardTriangle
                      : '';
                let changeColor =
                  sig1 < 0
                    ? 'red'
                    : sig1 > 0
                      ? 'green'
                      : chartproperties.darkTheme
                        ? 'white'
                        : 'black';
                c++;

                if (Number(changeText) > 0) {
                  changeText = '+' + changeText;
                }
                let text1 =
                  '<span>' +
                  text +
                  (pointWithMetric.y1 != null && changeText
                    ? '&nbsp<span style="color:' +
                      ';"> ' +
                      '<span style="font-size: 80%; color:' +
                      changeColor +
                      ';">(' +
                      changeText +
                      ')</span> &nbsp' +
                      '<span style="color:' +
                      sColor +
                      ';">' +
                      s +
                      '</span>'
                    : '') +
                  '</span>';
                pointWithMetric.tooltip = text1;
                return text1;
              }
            },
            connectorDashStyle: 'dashed',
          },
        },
      },
      //series: this.seriesdata,
      series: this.seriesdata.map((s: any) => ({
        ...s,
        zMin: 0,
        //zMax: 100,
      })),
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: false,
      },
    } as any);
    if (this.innerCircleDisplayValue) {
      setTimeout(() => {
        const chart = this.chart as any;
        if (this.innerCircleDisplayValue) {
          setTimeout(() => {
            const chart = this.chart as any;
            if (!chart || !chart.series) return;

            const _vpIdx = this.innerCircleName ? 1 : 0;
            const vpSeries = chart.series[_vpIdx];
            if (!vpSeries?.center) return;

            const centerX = vpSeries.center[0] + chart.plotLeft;
            const centerY = vpSeries.center[1] + chart.plotTop;

            const existing = document.getElementById('inner-circle-' + this.id);
            if (existing) existing.remove();
            document
              .querySelectorAll('.inner-circle-tooltip-' + this.id)
              .forEach((el) => el.remove());

            // Destroy previous text elements if re-rendering
            if (chart._innerValueText) {
              chart._innerValueText.destroy();
              chart._innerValueText = null;
            }
            if (chart._innerSigText) {
              chart._innerSigText.destroy();
              chart._innerSigText = null;
            }

            const tooltipEl = document.createElement('div');
            tooltipEl.className = 'inner-circle-tooltip-' + this.id;
            tooltipEl.innerHTML = `
                <div style="background:white;color:#333;padding:8px 12px;border-radius:4px;
                  font-size:0.5rem;pointer-events:none;display:none;z-index:9999;
                  white-space:nowrap;box-shadow:0 2px 8px rgba(0,0,0,0.15);border:1px solid #000;"
                  class="inner-tooltip-content">
                  <div style="display:flex;align-items:center;gap:8px;">
                    <div style="width:10px;height:0.5em;border-radius:50%;background:white;border:1px solid #000;flex-shrink:0;"></div>
                    <span>${this.innerCircleName}:</span>
                    <span style="font-weight:bold;">${this.innerCircleDisplayValue}${this.innerCircleSigText ? '<br><span style="color:' + this.innerCircleSigColor + ';font-weight:normal;">' + this.innerCircleSigText + '</span>' : ''}</span>
                  </div>
                </div>`;
            document.body.appendChild(tooltipEl);

            // Store reference so updatePosition() can reposition dynamically
            chart._innerValueText = chart.renderer
              .text(
                this.innerCircleDisplayValue,
                centerX,
                this.innerCircleSigText ? centerY - 6 : centerY,
              )
              .attr({ align: 'center', zIndex: 5 })
              .css({
                fontSize: this.chartproperties.dataLabelSize || '0.6em', // ✅ label size
                fontWeight: 'normal',
                cursor: 'pointer',
                color:
                  this.chartproperties.dataLabelColor === 'default'
                    ? this.chartproperties.darkTheme
                      ? 'white'
                      : 'black'
                    : this.chartproperties.dataLabelColor, // ✅ label color
              })
              .on('mouseover', (e: MouseEvent) => {
                const tc = tooltipEl.querySelector(
                  '.inner-tooltip-content',
                ) as HTMLElement;
                if (tc) {
                  tc.style.display = 'block';
                  tc.style.position = 'fixed';
                  tc.style.left = e.clientX + 10 + 'px';
                  tc.style.top = e.clientY - 30 + 'px';
                }
              })
              .on('mousemove', (e: MouseEvent) => {
                const tc = tooltipEl.querySelector(
                  '.inner-tooltip-content',
                ) as HTMLElement;
                if (tc) {
                  tc.style.left = e.clientX + 10 + 'px';
                  tc.style.top = e.clientY - 30 + 'px';
                }
              })
              .on('mouseout', () => {
                const tc = tooltipEl.querySelector(
                  '.inner-tooltip-content',
                ) as HTMLElement;
                if (tc) tc.style.display = 'none';
              })
              .add();
            if (this.innerCircleSigText) {
              chart._innerSigText = chart.renderer
                .text(this.innerCircleSigText, centerX, centerY + 10)
                .attr({ align: 'center', zIndex: 5 })
                .css({
                  fontSize: '0.5em',
                  color: this.innerCircleSigColor,
                  cursor: 'default',
                })
                .add();
            }
          }, 100);
        }
      }, 0); // ← closes the outer setTimeout(() => {
    }

    if (this.multiPropellerPopup) {
      setTimeout(() => this.createMultiBrandPopupLegend(), 600);
    }
  }
  // oncheckboxchecked(event: any, checkboxchecked: any) {
  //   this.piechartservice.commonfunction(
  //     event,
  //     checkboxchecked,
  //     this.chartproperties
  //   );
  //   this.plotChart('chart-container', this.jsondata['data'], this.chartproperties);
  // }
  userselectedproperties() {
    // this.jsondata['data']=this.jsondata['data'].slice(0,10);
    this.jsondata['properties'][0] = this.chartproperties;
    return JSON.stringify(this.jsondata).toString();
  }

  applycustomization(event: any, item: string) {
    //choose the appropriate customization
    this.piechartservice.applycustomization(event, item, this.chartproperties);
    //this.plotChart('chart-container',this.jsondata['data'],this.chartproperties);
    this.plotChart(
      'chart-container' + this.id,
      this.jsondata['data'],
      this.chartproperties,
    );
  }

  ngOnDestroy(): void {
    this.updateSigSub?.unsubscribe();
    this.subscriptions.unsubscribe();
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }
}
